import { render, staticRenderFns } from "./InputSuggestion.vue?vue&type=template&id=65ea0d1d"
import script from "./InputSuggestion.vue?vue&type=script&lang=js"
export * from "./InputSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports